const { cxt } = require('./context');

const {
  sales,
} = require('../schema');

const {
  accounting,
} = sales;

/**
 * Validates the VX Accounting Fee from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxAccountingFeeValidator = [
  cxt('schema', { schema: accounting.fee }),
];

/**
 * Validates the Accounting Fee along with Fee Configuration from incoming Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxAccountingFeeConfigValidator = [
  cxt('schema', { schema: accounting.feeConfiguration }),
];

module.exports = {
  salesVxAccountingFee: salesVxAccountingFeeValidator,
  salesAccountingFeeConfiguration: salesVxAccountingFeeConfigValidator,
};
